import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';
import { AccountsAndServicesComponent } from './accounts-and-services/accounts-and-services.component';
import { AppPrefillComponent } from './app-prefill/app-prefill.component';
import { AssetAllocationComponent } from './asset-allocation/asset-allocation.component';
import { AutofillApplicationComponent } from './autofill-application/autofill-application.component';
import { AutofillControlBaseComponent } from '../control-base/autofill-control-base.component';
import { AutofillInformationDriverLicenseComponent } from './autofill-info-driver-license/autofill-info-driver-license.component';
import { DisclosureComponent } from './disclosure/disclosure.component';
import { DynamicCustomFieldComponent } from './dynamic-custom-field/dynamic-custom-field.component';
import { DynamicEligibilityComponent } from './dynamic-eligibility/dynamic-eligibility.component';
import { DynamicPersonalInfoComponent } from './dynamic-personal-info/dynamic-personal-info.component';
import { JointCreditSelectComponent } from './joint-credit-select/joint-credit-select.component';
import { OaoIdentityVerificationComponent } from './Identity-verification/identityVerification.Component';
import { OLALoanTypeComponent } from './ola-loan-type/ola-loan-type.component';
import { FieldGroupCardComponent } from './field-group-card/field-group-card.component';
import { PercentValidator } from './percent.validator';
import { EconsentComponent } from './econsent/econsent.component';
import { RequestedDocumentComponent } from './requested-doc/requested-doc.component';
import { CrossSellComponent } from './cross-sell/cross-sell.component';
import { AutofillPreviewComponent } from './autofill-preview/autofill-preview.component';
import { OaoModule } from '@workflow/ecp-workflow/oao/oao.module';
import { OlaModule } from '@workflow/ecp-workflow/ola/ola.module';
import { EcpSharedModule } from '@workflow/ecp-shared/shared.module';
import { PagesModule } from '../pages/pages.module';
import { BuildingBlockControlBaseComponent } from './building-block.types';
import { DynamicDirectiveModule } from '@workflow/directive/dynamic-directive.module';
import { ControlsModule } from '@workflow/dynamic-render/building-block/controls/controls.module';
import { BuildingBlockSharedModule } from '@workflow/dynamic-render/building-block/shared/shared.module';
import { ValidationsModule } from '@workflow/dynamic-render/validations/validations.module';
import { DynamicPipeModule } from '@workflow/pipe/dynamic-pipe.module';
import { PaymentCalculatorComponent } from './payment-calculator/payment-calculator.component';
import { SharedModule } from '@shared/shared.module';
import { AlloyVerificationComponent } from './alloy-verification/alloy-verification.component';
import { EConsentSplashComponent } from './econsent-splash-screen/econsent-splash-screen.component';
import { SmartSignComponent } from './smart-sign/smart-sign.component';
import { PdfEmbedComponent } from "@cudirect/shared-ui-library/pdf-embed";

export const buildingBlockComponents = [
  AccountsAndServicesComponent,
  AutofillPreviewComponent,
  AppPrefillComponent,
  AssetAllocationComponent,
  AutofillApplicationComponent,
  AutofillControlBaseComponent,
  AutofillInformationDriverLicenseComponent,
  DisclosureComponent,
  DynamicEligibilityComponent,
  DynamicCustomFieldComponent,
  DynamicPersonalInfoComponent,
  JointCreditSelectComponent,
  OaoIdentityVerificationComponent,
  OLALoanTypeComponent,
  FieldGroupCardComponent,
  PercentValidator,
  EconsentComponent,
  RequestedDocumentComponent,
  CrossSellComponent,
  PaymentCalculatorComponent,
  AlloyVerificationComponent,
  EConsentSplashComponent,
  SmartSignComponent
];

@NgModule({
  declarations: [...buildingBlockComponents, BuildingBlockControlBaseComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    SharedUiLibraryModule,
    SharedModule,
    ControlsModule,
    BuildingBlockSharedModule,
    DynamicDirectiveModule,
    DynamicPipeModule,
    ValidationsModule,
    EcpSharedModule,
    PagesModule,
    OaoModule,
    OlaModule,
    PdfEmbedComponent
],
  exports: [...buildingBlockComponents, BuildingBlockControlBaseComponent]
})
export class BuildingBlockModule {}
